import { Injectable }                        from "@angular/core";
import { CONFIGURATION }                     from "../../../app.constants";
import { USERHOMECONSTANTS }                 from "../../../modules/userHome";
import { Organisation, OrganisationWorkflow, AccountRole }
from "../../../models";
import { Observable }                        from "rxjs/Observable";
import { HttpDataService }                   from "../../../services/shared";

@Injectable()
export class OrganisationWorkflowService {

    constructor(private httpData: HttpDataService) { }

    public getWorkflowByTaskId(taskId: string, taskType: string): Observable<OrganisationWorkflow[]> {
        let filter = `$filter=TaskId eq ${taskId} and OrganisationStatusCode eq '${USERHOMECONSTANTS.organisationStatus.pending}'`;
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}organisationWorkflow/Search?${filter}`;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <OrganisationWorkflow[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public GetWorkflowTaskMessage(taskId: string): Observable<OrganisationWorkflow> {
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}organisation/GetWorkflowTaskById?taskId=${taskId}`;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <OrganisationWorkflow>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }


    public getOrganisation(userId: string, taskId: string): Observable<Organisation> {
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}organisation/GetWorkflowUserByIdTaskId?userId=${userId}&taskId=${taskId}`;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <Organisation>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public submitWorkflow(organisationWorkflow: OrganisationWorkflow): Observable<boolean> {
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}organisationWorkflow`;

        return Observable.create((observer) => {
            this.httpData.post(dataUrl, JSON.stringify(organisationWorkflow))
                .map(response => <boolean>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

     public GetRoles(): Observable<AccountRole[]> {
        return Observable.create((observer) => {
            this.httpData.get(CONFIGURATION.baseUrls.apiUrl + "common/GetRoles")
                .map(response => <AccountRole[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/workflow/organisation/organisationWorkflow.service.ts